<div leftActions class="ntv-dropdown__wrapper" title="Clear selected item">
    <ntv-dropdown
        [value]="selectedValue() ?? null"
        [options]="options()"
        (selectionChange)="onSelectionChange($event)"
        [placeholder]="placeholder()" />
    @if (selectedValue()) {
        <div class="ntv-dropdown__remove-icon-wrapper" (click)="clearSelection()">
            <span class="ntv-dropdown__remove-icon">
                <svg width="12" height="12">
                    <use xlink:href="assets/icons/icons-sprite.svg#close"></use>
                </svg>
            </span>
        </div>
    }
</div>
